import React, { ButtonHTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { CustomButton } from "./CustomButton";

interface ToolbarButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "title"> {
  icon: ReactNode;
  title?: ReactNode;
  showLabelOnMobile?: boolean;
  tooltip?: string;
}

export const ToolbarButton = ({
  icon,
  title,
  showLabelOnMobile = false,
  tooltip,
  className,
  ...props
}: ToolbarButtonProps) => (
  <CustomButton
    type="button"
    variant="none"
    size="sm"
    icon={icon}
    title={title}
    titleClassName={twMerge(
      "whitespace-nowrap",
      showLabelOnMobile ? undefined : "hidden lg:flex"
    )}
    tooltip={tooltip ?? (typeof title === "string" ? title : undefined)}
    className={twMerge(
      "inline-flex gap-1.5 rounded-md px-2 font-medium text-gray-500 enabled:hover:bg-gray-100 enabled:hover:text-gray-700 sm:px-2.5",
      className
    )}
    {...props}
  />
);

export const ToolbarDivider = () => (
  <span className="mr-1 hidden h-6 w-px bg-gray-200 sm:block" />
);

ToolbarButton.displayName = "ToolbarButton";
